import React, { useState, useRef, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  TextField,
  InputAdornment,
  Button,
  List,
  ListItemButton,
  ListItemText,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import FrameIcon from "../../../src/assests/images/frameIcon.svg";
import ExtendsDate from "./ExtendsDate";
import FilterTags from "../AssignTask/FilterTags";
import CalendarCircle from "../../../src/assests/images/calendar-circle.svg";
import CalendarGreen from "../../../src/assests/images/calendar-green.svg";
import CalendarRed from "../../../src/assests/images/calendar-red.svg";
import Edit from "../../../src/assests/images/edit-2.svg";
import Dublicate from "../../../src/assests/images/dublicate-icon.svg";import { duplicatetasks } from "../../pages/tasks/api";

import { getToken } from "../../utils/utils";
import sorterArrow from "../../../src/assests/images/SortingArrow.svg";
import SearchIcon from "@mui/icons-material/Search";
import PaginationComponent from "../AssignTask/Pagination";

// Custom debounce hook
function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

// Define the Cohort type
export interface Cohort {
  id: string;
  task_id: string;
  taskTitle: string;
  title: string;
  totalUsers: number;
  assignedDate: string;
  endDate: string;
  tag: string;
  status: string;
  task_status: string;
  applied_filters: any; // Replace with specific type if known
  days_extenstions: number;
  actual_end_date: string;
  points: number;
  created_at: string;
  approvedCount: number;
}

// Define props for CohortCard
interface CohortCardProps {
  cohort: Cohort;
  onDuplicate: (cohort: Cohort) => Promise<void>;
}

// Define props for CompletedTask
interface CompletedTaskProps {
  searchTermcomplted: string;
  setSearchTermcomplted: React.Dispatch<React.SetStateAction<string>>;
  activeTaskData: Cohort[];
  title: string;
  sortOption: "highest" | "lowest" | null;
  setSortOption: React.Dispatch<React.SetStateAction<"highest" | "lowest" | null>>;
  loading: boolean;
}

const CohortCard: React.FC<CohortCardProps> = ({ cohort, onDuplicate }) => {
  const [open, setOpen] = useState(false);
  const [cohorttitel, setcohorttitel] = useState("");
  const [taskid, settaskid] = useState("");
  const [cohortassigneddate, setcohortassigneddate] = useState("");
  const [cohortendDate, setcohortendDate] = useState("");
  const [cohortendDate22, setcohortendDate22] = useState("");
  const navigate = useNavigate();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleLinkClick = (
    status: string,
    cohortId: string,
    cohorttitle: string,
    cohortassigneddate: string,
    cohortendDate: string,
    cohorttaskids: string,
    tag: string
  ) => {
    if (status === "Edit Task") {
      handleOpen();
    } else if (status === "Extend Task Duration") {
      handleOpen();
      setcohorttitel(cohorttitle);
      settaskid(cohorttaskids);
      setcohortassigneddate(cohortassigneddate);
      setcohortendDate22(cohortendDate);
      const assignedDate = new Date(cohortassigneddate);
      const endDate = new Date(cohortendDate);

      assignedDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      const diffInTime = endDate.getTime() - assignedDate.getTime();
      const diffInDays = diffInTime / (1000 * 60 * 60 * 24);

      setcohortendDate(`${diffInDays} Days`);
    }
  };

  const handleDuplicateClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigate(`/manage-task/duplicate-task/${cohort.task_id}`);
  };

  return (
    <>
      <Card
        sx={{
          maxWidth: "30%",
          minWidth: "30%",
          margin: 2,
          border: "1px solid rgba(0, 0, 0, 0.12)",
          boxShadow: "none",
          borderRadius: "10px",
          "&:hover": {
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
            transition: "box-shadow 0.3s ease, transform 0.3s ease",
          },
        }}
      >
        <CardContent
          onClick={() =>
            navigate(`/active-task/assign-task/${cohort.task_id}/completed_task`)
          }
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              borderBottom: "1px dashed #d0d0d0 !important",
              marginBottom: "10px",
              paddingBottom: "10px",
            }}
          >
            <Box>
              <Typography
                sx={{ color: "#696A6B", fontSize: "14px", display: "flex" }}
              >
                <img src={FrameIcon} alt="FrameIcon" />
                <Typography sx={{ margin: "0px 10px" }}>
                  {cohort.taskTitle}
                 <Tooltip title={cohort.title} arrow>
  <Typography
    sx={{
      fontSize: "18px",
      color: "#282829",
      fontWeight: "bold",
      maxWidth: 150,          // limit width (adjust as needed)
      whiteSpace: "nowrap",   // keep text on one line
      overflow: "hidden",     // hide overflow
      textOverflow: "ellipsis", // show "..." if text is too long
      display: "block",
      cursor: "pointer",      // hint that it’s hoverable
    }}
    variant="h6"
  >
    {cohort.title}
  </Typography>
</Tooltip>
                </Typography>
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: "12px",
                  color: cohort.tag === "Not Published" ? "#696A6B" : "#2E844A",
                  background:
                    cohort.tag === "Not Published" ? "#E3E3E3" : "#EBF7E6",
                  padding: "7px 10px",
                  borderRadius: "10px",
                  fontWeight: "600",
                }}
              >
                {cohort.tag}
              </Typography>
            </Box>
            <Box>
              <img
                src={Dublicate}
                alt="Duplicate Icon"
                style={{ cursor: "pointer", width: "23px" }}
                onClick={handleDuplicateClick}
              />
            </Box>
          </Box>
          <Typography
            variant="body1"
            sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
          >
            Credit Points: <b style={{ color: "#282829" }}>{cohort.points}</b>
          </Typography>
                    <Typography
            variant="body1"
            sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
          >
            Created By: <b style={{ color: "#282829" }}>{"Admin"}</b>
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
          >
            Created At: <b style={{ color: "#282829" }}>{cohort.created_at}</b>
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
          >
            Task Status: <b style={{ color: "#282829" }}>{"Completed"}</b>
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
          >
            Total Users: <b style={{ color: "#282829" }}>{cohort.approvedCount}</b>
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
          >
            Assigned Date: <b style={{ color: "#282829" }}>{cohort.assignedDate}</b>
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
          >
            End Date: <b style={{ color: "#282829" }}>{cohort.endDate}</b>
          </Typography>
        </CardContent>
      </Card>
      <ExtendsDate
        open={open}
        onClose={handleClose}
        cohorttitel={cohorttitel}
        cohortassigneddate={cohortassigneddate}
        cohortendDate22={cohortendDate22}
        cohortendDate={cohortendDate}
        taskid={taskid}
      />
    </>
  );
};

const CompletedTask: React.FC<CompletedTaskProps> = ({
  searchTermcomplted,
  setSearchTermcomplted,
  activeTaskData,
  title,
  sortOption,
  setSortOption,
  loading,
}) => {
  const [cohorts, setCohorts] = useState<Cohort[]>(activeTaskData);
  const [localSearchTerm, setLocalSearchTerm] = useState(searchTermcomplted);
  const sortButtonRef = useRef<HTMLButtonElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // Sync cohorts with activeTaskData whenever it changes
  useEffect(() => {
    setCohorts(activeTaskData);
  }, [activeTaskData]);

  // Debounce the local search term
  const debouncedSearchTerm = useDebounce(localSearchTerm, 500);

  // Update parent's searchTermcomplted when debouncedSearchTerm changes
  useEffect(() => {
    setSearchTermcomplted(debouncedSearchTerm);
  }, [debouncedSearchTerm, setSearchTermcomplted]);

  const token = getToken();

  const handleSortButtonClick = () => setIsPopupOpen((prev) => !prev);

  const handleSortSelection = (option: "highest" | "lowest") => {
    setSortOption(option);
    setIsPopupOpen(false);
  };

  console.log(searchTermcomplted, "searchTermcomplted444");

  const handleDuplicate = async (cohort: Cohort) => {
    try {
      const data = await duplicatetasks(token, cohort.task_id);
      const newCohort: Cohort = {
        ...cohort,
        id: `${cohort.id}-${Date.now()}`,
      };
      setCohorts([...cohorts, newCohort]);
    } catch (error) {
      console.error("Error duplicating task:", error);
    }
  };

  console.log(cohorts, "cohssssssssssssssort");

  return (
    <>
        <Box sx={{ padding: "0 32px" }}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography
          sx={{ fontSize: "16px", fontWeight: "600", marginBottom: "20px" }}
        >
          {title}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "24px",
          marginBottom: "42px",
        }}
      >
        <TextField
          required
          placeholder="Search by Task Name, Task Type"
          sx={{
            ".MuiOutlinedInput-root": {
              borderRadius: "12px",
              height: "48px",
              width: "521px",
              "@media (max-width:1366px)": {
                width: "400px",
              },
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          value={localSearchTerm}
          onChange={(e) => setLocalSearchTerm(e.target.value)}
        />

        {/* Sort Button */}
        <Box sx={{ position: "relative" }}>
          <Button
            ref={sortButtonRef}
            onClick={handleSortButtonClick}
            variant="outlined"
            sx={{
              height: "48px",
              borderRadius: "12px",
              minWidth: "200px",
              textTransform: "none",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            Sort By UpdateAt
            <img
              src={sorterArrow}
              alt="Sort Arrow"
              style={{ width: "16px", height: "16px" }}
            />
          </Button>

          {isPopupOpen && (
            <Box
              ref={popupRef}
              sx={{
                position: "absolute",
                top: "55px",
                right: 0,
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                borderRadius: "8px",
                zIndex: 999,
                width: "200px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
              }}
            >
              <List>
                <ListItemButton onClick={() => handleSortSelection("highest")}>
                  <ListItemText primary="⬇️ Highest to Lowest" />
                </ListItemButton>
                <ListItemButton onClick={() => handleSortSelection("lowest")}>
                  <ListItemText primary="⬆️ Lowest to Highest" />
                </ListItemButton>
              </List>
            </Box>
          )}
        </Box>
      </Box>

      {/* Main Content */}
      <Box sx={{ position: "relative", marginTop: "20px" }}>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "200px",
              width: "100%",
            }}
          >
            <CircularProgress />
          </Box>
        ) : cohorts.length > 0 ? (
          <Grid container spacing={2} >
            {cohorts.map((cohort) => (
              <CohortCard
                key={cohort.id}
                cohort={cohort}
                onDuplicate={handleDuplicate}
              />
            ))}
          </Grid>
        ) : (
          <Typography sx={{ textAlign: "center", width: "100%", mt: 3 }}>
            No data available
          </Typography>
        )}
      </Box>
      </Box>
    </>
  );
};

export default CompletedTask;